class CollectionInfo extends HTMLElement {
  constructor() {
    super();
    this._toggleHandler = this.toggle.bind(this);
  }

  connectedCallback() {
    const full = this.dataset.text || "";
    const limit = parseInt(this.dataset.limit || "20", 10);

    this.fullText  = full;
    this.limit     = limit;
    this.shortText = this._getShortText(full, limit);

    const isTruncated = this.shortText.length < this.fullText.length;

    this.innerHTML = `
      <p class="ci-short p-0 m-0">${this.shortText}${isTruncated ? "..." : ""}</p>
      <p class="ci-full p-0 m-0" style="display:none;">${this.fullText}</p>
      ${isTruncated 
        ? '<a type="button" class="ci-toggle btn btn-link p-0">הצג עוד</a>'
        : ''
      }
    `;

    this.shortEl = this.querySelector(".ci-short");
    this.fullEl  = this.querySelector(".ci-full");
    this.btn     = this.querySelector(".ci-toggle");

    if (this.btn) {
      this.btn.addEventListener("click", this._toggleHandler);
    }
  }

  

  disconnectedCallback() {
    if (this.btn) {
      this.btn.removeEventListener("click", this._toggleHandler);
    }
  }

  _getShortText(text, limit) {
    const words = text.split(/\s+/);
    if (words.length <= limit) return text;
    return words.slice(0, limit).join(" ");
  }

  toggle() {
    const isOpen = this.fullEl.style.display !== "none";

    if (isOpen) {
      this.fullEl.style.display = "none";
      this.shortEl.style.display = "block";
      this.btn.textContent = "הצג עוד";
    } else {
      this.fullEl.style.display = "block";
      this.shortEl.style.display = "none";
      this.btn.textContent = "הסתר";
    }
  }
}

customElements.define("collection-info", CollectionInfo);
